import actions from '../action/address'
import CONSTANT from '../constant/address'
import COOKIECONSTANT from '../constant/cookie'
import _ from 'underscore'
import op from 'object-path'
import { cityIdFormat, provinceIdFormat } from '../util/function'

export default {
    actions,
    state: {
        addressList: [],
        selectedAddress: {},
        isAddressPicker: false, //是否显示选择收货地址页面
        centerAddress: {}, //中心点地址
    },
    mutations: {
        clearSelectedAddress(state) {
            _.each(state.addressList, (addr) => {
                addr.isSelected = false
            })
            state.selectedAddress = {}
        },
        clearAddress(state) {
            state.addressList = [],
            state.selectedAddress = {}
        },
        setSelectedAddress(state,{index,id} ) {
            _.each(state.addressList, (addr) => {
                addr.isSelected = false
            })
            if(index != undefined){
                state.addressList[index].isSelected = true
                state.selectedAddress = state.addressList[index]
            }else if(id != undefined){

                _.each(state.addressList, addr => {
                    if(addr.addressId == id){
                        addr.isSelected = true
                        state.selectedAddress = addr
                    }
                })
            }


        },
        [CONSTANT.ADDRESS_GET_LIST_SUCCESS] (state, list) {
            //找到默认地址
            let defaultAddr = _.find(list, (address) => {
               return  address.isDefault == 1
            });
            //找到非默认地址
            let notDefault = _.filter(list, (address) => {
                return address.isDefault == 0
            })
            //将默认地址加到地址头
            if(defaultAddr && notDefault){
                notDefault.unshift(defaultAddr)
            }
            let newList = _.filter(notDefault, address => address) //过滤掉undefined
            //初始化被选择状态
            _.each(newList, (addr) => {
                addr.isSelected = false
            })
            //如果没有已经被选的地址，则选中地址为默认地址
            if(_.isEmpty(state.selectedAddress)){
                newList[0].isSelected = true
                state.selectedAddress = newList[0]
            }else {
                _.each(newList,addr => {
                    if(addr.addressId == state.selectedAddress.addressId){
                        addr.isSelected = true
                    }
                })
            }


            state.addressList = newList
        },
        [CONSTANT.ADDRESS_GET_LIST_ERROR] (state, e) {
            return state.addressList = []
        },
        [CONSTANT.ADDRESS_GET_LIST_ERROR_EMPTY] (state, e) {
            return state.addressList = []
        },
        [CONSTANT.ADDRESS_GETDEFAULTADDRESS_SUCCESS] (state, data) {

        },
        [CONSTANT.ADDRESS_GETDEFAULTADDRESS_ERROR] (state, e) {

        },
        [CONSTANT.ADDRESS_ADDADDRESS_SUCCESS] (state, data) {

        },
        [CONSTANT.ADDRESS_ADDADDRESS_ERROR] (state, e) {

        },
        [CONSTANT.ADDRESS_UPDATEADDRESS_SUCCESS] (state, data) {

        },
        [CONSTANT.ADDRESS_UPDATEADDRESS_ERROR] (state, e) {

        },
        [CONSTANT.ADDRESS_DELETEADDRESS_SUCCESS] (state, data) {

        },
        [CONSTANT.ADDRESS_DELETEADDRESS_ERROR] (state, e) {

        },
        [CONSTANT.ADDRESS_CHANGEDEFAULTADDRESS_SUCCESS] (state, data) {
            if(!data){
                return
            }else if(data.addressId){
                let addressId = data.addressId
                _.each(state.addressList,addr => {
                    addr.isDefault = addr.addressId == addressId ? 1: 0
                })
            }
        },
        [CONSTANT.ADDRESS_CHANGEDEFAULTADDRESS_ERROR] (state, e) {

        },
        [CONSTANT.ADDRESS_SET_IS_SEARCH] (state, data) {
            state.isAddressPicker = data
        },
        [CONSTANT.ADDRESS_GET_CENTER_SUCCESS](state, data) {
            // 高德api返回adcode = 省+市+区 6位编码
            state.centerAddress = {
                cityId: cityIdFormat(op(data).get('regeocode.addressComponent.adcode')|| data.adcode),
                cityName: op(data).get('regeocode.addressComponent.city') || data.cityname,
                districtId: op(data).get('regeocode.addressComponent.adcode') || data.adcode,
                districtName: op(data).get('regeocode.addressComponent.district') || data.adname,
                provinceId: provinceIdFormat(op(data).get('regeocode.addressComponent.adcode') || data.adcode),
                provinceName: op(data).get('regeocode.addressComponent.province') || data.pname,
                name: op(data).get('regeocode.aois.0.name') || data.name,
                address: data.formattedAddress || data.address,
                location: op(data).get('position') || data.location
            }
        },
        [CONSTANT.ADDRESS_GET_CENTER_ERROR](state, e) {
            state.centerAddress = {}
        }
        /*yeoman-template-point-1*/
    },
    getters: {
        getCenterAddress: state => {
            // 移动后中心点地址 > 用户选择后的地址 > GPS定位的地址
            return state.centerAddress.name && state.centerAddress || JSON.parse(localStorage.getItem(COOKIECONSTANT.COOKIE_USER_SELECT_ADDRESS_BY_ADD)) || JSON.parse(localStorage.getItem(COOKIECONSTANT.COOKIE_DEFAULT_SHIPPING_ADDRESS))
        }
    }
}
